import { useTranslation } from "react-i18next";
import type { RenderMode } from "@crashx/shared";

interface Props {
  mode: RenderMode;
  available: readonly RenderMode[];
  onChange: (mode: RenderMode) => void;
}

export function ModeSelector({ mode, available, onChange }: Props) {
  const { t } = useTranslation();
  return (
    <label className="cx-player-mode" htmlFor="game-render-mode">
      {t("game.renderMode")}
      <select
        id="game-render-mode"
        aria-label={t("game.renderMode")}
        className="cx-input"
        value={mode}
        onChange={(event) => {
          const selected = available.find((id) => id === event.target.value);
          if (selected) onChange(selected);
        }}
      >
        {available.map((id) => (
          <option key={id} value={id}>
            {t(`game.modes.${id}`)}
          </option>
        ))}
      </select>
    </label>
  );
}
